// extracted by mini-css-extract-plugin
var _1 = "modalAnket-module_anketBtns__YtLbwv";
var _2 = "modalAnket-module_dialogActions__iM2Hzn";
var _3 = "modalAnket-module_dialogContnent__ZakJMd";
var _4 = "modalAnket-module_dialog_paper__eRoiND";
var _5 = "modalAnket-module_ellipsBtn__Mp8aiY";
var _6 = "modalAnket-module_ellipsLoadingBtn__NT_ztW";
var _7 = "modalAnket-module_input__Sd40dO";
var _8 = "modalAnket-module_loaadinIcon__UjSzH_";
var _9 = "modalAnket-module_question_text__EYuRpd";
var _a = "modalAnket-module_title__c_v_6W";
export { _1 as "anketBtns", _2 as "dialogActions", _3 as "dialogContnent", _4 as "dialog_paper", _5 as "ellipsBtn", _6 as "ellipsLoadingBtn", _7 as "input", _8 as "loaadinIcon", _9 as "question_text", _a as "title" }
